/** Every route string in the application originates here. */
export const paths = {
  root: '/',
  dashboard: '/dashboard',
  login: '/login',
  studio: '/studio',
  studioThread: '/studio/:sessionId',
  history: '/history',
  usage: '/usage',
  userUsage: '/usage/users/:userId',
  models: '/models',
  people: '/people',
  personDetail: '/people/users/:userId',
  groups: '/people/groups',
  groupDetail: '/people/groups/:groupId',
  designSystem: '/design-system',
  unauthorized: '/unauthorized',
}

/** Builds the path for one conversation thread. */
export const threadPath = (sessionId) => `/studio/${sessionId}`

/** Builds the detail path for one person in the People module. */
export const personPath = (userId) => `/people/users/${userId}`

/** Builds the detail path for one group. */
export const groupPath = (groupId) => `/people/groups/${groupId}`

/** Builds the detail path for one user's usage. */
export const userUsagePath = (userId) => `/usage/users/${userId}`

/** Search-param key the login page uses to return people where they were. */
export const REDIRECT_PARAM = 'from'
